import {useState,useEffect} from 'react';
import realtimeDB from "../Utils/api";
import moment from "moment";

const usePopups=()=>
{
    const [Popups, setPopups] = useState([]);
    useEffect(() => 
    {
        const HoraActual=new Date().getHours();
        const MinutoActual=new Date().getMinutes();


        realtimeDB.ref("/pop-ups").on("value",snapshot =>
        {   
          
            let popups=[];
            snapshot.forEach(popup =>
            {
                const Popup = { id:popup.key, data:popup.val() }

                // if(!Popup.data.Activo) continue;

                const Inicio = new Date(Popup.data.HoraInicio);
                const Fin    = new Date(Popup.data.HoraFin);


                
                const HoraInicio = Inicio.getHours();
                const MinutosInicio = Inicio.getMinutes();

                const HoraFin = Fin.getHours();
                const MinutosFin  = Fin.getMinutes();

                console.log(HoraInicio,MinutosInicio,HoraFin,MinutosFin)
                

                if(HoraActual >= HoraInicio || HoraActual <= HoraFin)
                {
                    if(MinutoActual >= MinutosInicio || MinutoActual <= MinutosFin)
                    {
                        popups.push(Popup);
                    }
                }
            });
            
            setTimeout(() =>
            {
                setPopups(popups);
            }, 1500);
        })
    }, [])
    return Popups;
}

export default usePopups;
